class CurrencyUtils {
}
CurrencyUtils.DEFAULT_SEPARATORS = { decimalSeparator: ',', literalSeparator: ' ' };
CurrencyUtils.toNumber = (currency, { decimalSeparator = ',', literalSeparator = ' ' } = CurrencyUtils.DEFAULT_SEPARATORS) => {
    if (!isNaN(Number(currency))) {
        return Number(currency);
    }
    if (literalSeparator === '') {
        literalSeparator = '/s';
    }
    const doesContainDecimalSeparator = currency.indexOf(decimalSeparator) !== -1;
    const doesContainDotAsSeparator = currency.indexOf('.') !== -1;
    const doesContainCommaAsSeparator = currency.indexOf(',') !== -1;
    if (!doesContainDecimalSeparator) {
        if (doesContainDotAsSeparator) {
            currency = currency.replace('.', decimalSeparator);
        }
        if (doesContainCommaAsSeparator) {
            currency = currency.replace(',', decimalSeparator);
        }
    }
    const everythingThatIsNotDigitOrSeparator = new RegExp(`[^\\d\\${decimalSeparator}\\${literalSeparator}]`, 'g');
    const everythingThatIsDecimalSeparator = new RegExp(`\\${decimalSeparator}`, 'g');
    const everythingThatIsLiteralSeparator = new RegExp(`\\${literalSeparator}`, 'g');
    const currencyNumber = currency
        .replace(everythingThatIsNotDigitOrSeparator, '')
        .replace(everythingThatIsLiteralSeparator, '')
        .replace(everythingThatIsDecimalSeparator, '.');
    return parseFloat(currencyNumber);
};

export { CurrencyUtils };
//# sourceMappingURL=currency_utils.js.map
